/**
 * Qué abrir después de archivar, eliminar o mover a Spam desde el lector (M32, auditoría 2026-10-02).
 * `orden`: las filas de la lista tal como se ven ({ accountId, folder, uid }). Va al siguiente; si era el
 * último, al anterior; si no estaba en la lista o era el único, a ninguno (se vuelve a la lista).
 */
export function siguienteTrasMover(orden, actual) {
  const misma = (f) => String(f.uid) === String(actual?.uid)
    && (!actual?.accountId || f.accountId === actual.accountId);
  const i = (orden || []).findIndex(misma);
  if (i < 0) return null;
  return orden[i + 1] || orden[i - 1] || null;
}

/**
 * En «Destacados» y «Todos» lo archivado sigue a la vista (Destacados = con estrella en Recibidos, Archivo o Enviados,
 * como Gmail). Sin explicarlo parecía que archivar no funcionaba (Gabriel, 2026-10-06): el aviso lo dice.
 */
export function avisoArchivado(vista, conEstrella, n = 1) {
  const que = n === 1 ? 'Archivado' : `${n} archivados`;
  if (vista === 'starred' && conEstrella) return `${que} · ${n === 1 ? 'sigue' : 'siguen'} en Destacados porque ${n === 1 ? 'tiene' : 'tienen'} estrella`;
  if (vista === 'all') return `${que} · ${n === 1 ? 'sigue' : 'siguen'} en «Todos»`;
  return `${que} · lo encuentras en «Todos»`.replace('lo encuentras', n === 1 ? 'lo encuentras' : 'los encuentras');
}

/**
 * Marca como archivadas (`_archivado`, solo para pintar la etiqueta) las filas que se acaban de archivar en una vista
 * donde siguen a la vista. NO cambia su carpeta: la fila conserva el uid de Recibidos hasta el refresco, y con la
 * carpeta «archive» una acción inmediata caería sobre otro correo (el uid cambia al mover).
 */
export function marcarArchivadas(old, correos) {
  if (!old?.pages) return old;
  const movida = (m) => correos.some((c) => c.accountId === m.accountId && String(c.uid) === String(m.uid)
    && (!m.folder || !c.folder || m.folder === c.folder));
  return {
    ...old,
    pages: old.pages.map((p) => (p?.messages
      ? { ...p, messages: p.messages.map((m) => (movida(m) ? { ...m, _archivado: true } : m)) }
      : p)),
  };
}
